import { matchMediaType } from '../../../utils';
import type {
  GalleryMediaValue,
  MediaValue,
  PictureValueType
} from '../../types';
import type { VkontakteAttachmentType } from '../types';

type VkontakteMediaValue = MediaValue<string | PictureValueType[]>;

export const getVkontakteMedia = (
  attachments: VkontakteAttachmentType[] = []
): VkontakteMediaValue | undefined => {
  if (!attachments.length) {
    return undefined;
  }

  const mediaItems = attachments.reduce<VkontakteMediaValue[]>(
    (acc, { photo, video, link, type: derivedType }) => {
      const type = matchMediaType(derivedType);

      if (type === 'image') {
        acc.push({
          type,
          src: photo?.sizes || ''
        });
      }

      if (type === 'link') {
        acc.push({
          type,
          title: link?.title || '',
          description: link?.description || '',
          url: link?.url || '',
          src: link?.photo?.sizes || ''
        });
      }

      if (type === 'video') {
        acc.push({
          type,
          src:
            video?.owner_id && video?.id
              ? `https://vk.com/video_ext.php?oid=${video.owner_id}&id=${video.id}`
              : '',
          videoFormat: video?.type,
          thumbnail: video?.image || ''
        });
      }

      return acc;
    },
    []
  );

  if (mediaItems.length > 1) {
    const typedMediaItems = mediaItems as GalleryMediaValue['items'];

    return {
      type: 'gallery',
      thumbnail: typedMediaItems[0].thumbnail ?? typedMediaItems[0].src ?? '',
      items: typedMediaItems
    };
  }

  return mediaItems[0];
};
